import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { FlexRow, LargeText } from '../content';
import { Spinner } from './Spinner';
const FullScreenSpinner = ({
  label,
  value,
  big
}) => {
  let content = null;
  if (label) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CircularProgress, {
      variant: "determinate",
      color: "primary",
      size: 120,
      value: value,
      style: {
        position: 'absolute',
        top: 'calc(50% - 60px)',
        left: 'calc(50% - 60px)'
      }
    }), /*#__PURE__*/React.createElement(LargeText, {
      margin: "auto"
    }, label));
  } else {
    content = /*#__PURE__*/React.createElement(Spinner, {
      big: big
    });
  }
  return /*#__PURE__*/React.createElement(FlexRow, {
    margin: 0,
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: 4,
    top: 0,
    left: 0,
    backgroundColor: "rgba(255,255,255,0.8)",
    alignItems: "center",
    justifyContent: "center"
  }, content);
};
export { FullScreenSpinner };